import React from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";

const PickupDeliveryPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Full-width Section Header */}
      <div className="w-full bg-white">
        <SimpleSectionHeader title="Pickup and Delivery" />
        <div className="flex justify-center mt-2"></div>
      </div>

      {/* Main Content Container */}
      <div className="py-10 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-6 rounded-md">
            <p className="text-orange-700 font-semibold">
              There are Four slots for delivery and pick up :
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>
                If you order in the morning around 9am book will be delivered up
                to 12pm.
              </li>
              <li>
                 If you order in the afternoon around 12pm book will be
                delivered up to 3pm.
              </li>
              <li>
                 If you order in the afternoon around 3pm book will be delivered
                up to 6pm.
              </li>
              <li>
                If you order in the evening around 6pm book will be delivered up
                to 9pm.
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <p className="text-gray-700">
              And most important if you have ordered after 7pm the book will be
              deliver in the next morning around 9am. The books will be
              delivered to you as per your address given in the agreement and in
              between if you want to change any address please contact our
              Customer Care Executives.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PickupDeliveryPolicy;
